import { useState } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import FolderIconCircleFrosted from 'dibs-icons/exports/Folder';
import FolderIcon from 'dibs-icons/exports/legacy/Folder';
import FolderPlusIcon from 'dibs-icons/exports/legacy/FolderPlus'; // Helpers

import classnames from 'classnames'; // Styles
import dibsCss from 'dibs-css';
import styles from './styles.scss'; // Types

const messages = defineMessages({
    label: {
        id: 'dibs-portfolio-folder.FolderWrapperIcon.label',
        defaultMessage: 'Save to folder',
    },
});

const FolderIconWrapper = ({
    additionalButtonClass,
    additionalIconClass,
    theme,
    disabledButton = false,
    iconPosition = 'absolute',
    iconText,
    isInFolder = false,
    onClick = () => {},
    type = 'outline',
    isStrokeWidthHeavy = false,
    showPlusIcon,
    isAnimated,
    onAnimationEnd,
}) => {
    const intl = useIntl();
    const [isActive, setIsActive] = useState(false);
    const isButton = iconPosition === 'relative' || iconText;
    const isFolderPlusIcon = showPlusIcon && !isInFolder;
    const isCircleLight = theme === 'circle-light';
    const isCircleFrostedSmall = theme === 'circle-frosted-small';
    const isCircleFrostedMedium = theme === 'circle-frosted-medium';
    const isCircleFrostedLarge = theme === 'circle-frosted-large';
    const isCircleFrosted = isCircleFrostedSmall || isCircleFrostedMedium || isCircleFrostedLarge;
    const iconClasses = classnames(styles.icon, additionalIconClass, {
        [styles.isIcon]: !isButton,
        [styles.isButton]: isButton,
        [styles.isAnimated]: !isButton && isAnimated,
        [styles.isFilled]: isInFolder,
        [styles.isStrokeWidthHeavy]: isStrokeWidthHeavy,
        [styles.dark]: theme === 'dark',
        [styles.light]: theme === 'light',
        [styles.circleLight]: isCircleLight,
        [styles.circleIcon]: isCircleLight,
    });
    const iconShadowClasses = classnames(styles.iconShadow, {
        [styles.isAnimated]: isAnimated,
        [styles.dark]: theme === 'dark',
        [styles.light]: theme === 'light',
    });
    const dataTn = isInFolder ? 'folder-saved-icon' : 'folder-save-icon';
    const Folder = isFolderPlusIcon ? FolderPlusIcon : FolderIcon;

    if (iconPosition === 'relative' || iconText) {
        const buttonClasses = classnames(styles.iconButton, additionalButtonClass, {
            [styles.disabled]: disabledButton,
        });
        const buttonIconClasses = classnames(styles.icon, additionalIconClass);
        return (
            // My name is Martynas B. and I confess that I'm disabling this rule because I didn't have time to refactor this component © Kostas
            // eslint-disable-next-line react/forbid-elements
            <button
                className={buttonClasses}
                data-tn="add-to-folder"
                onClick={onClick}
                type="button"
            >
                <Folder className={buttonIconClasses} />
                {iconText && <span className={styles.text}>{iconText}</span>}
            </button>
        );
    }

    function toggleActive(active) {
        if (type === 'button') {
            setIsActive(active);
        }
    }

    let variation;
    if (isCircleFrostedSmall && isInFolder) {
        variation = '20Filled';
    } else if (isCircleFrostedSmall && !isInFolder) {
        variation = '20';
    } else if (!isCircleFrostedSmall && isInFolder) {
        variation = '24Filled';
    } else if (!isCircleFrostedSmall && !isInFolder) {
        variation = '24';
    }

    return (
        // My name is Martynas B. and I confess that I'm disabling this rule because I didn't have time to refactor this component © Kostas
        // eslint-disable-next-line react/forbid-elements
        <button
            aria-label={intl.formatMessage(messages.label)}
            className={classnames(styles.iconWrapper, additionalButtonClass, {
                [styles[type]]: type,
                [styles.isActive]: isActive,
                [styles.isStrokeWidthHeavy]: isStrokeWidthHeavy,
                [styles.circleIcon]: isCircleLight,
                [styles.circleFrostedWrapper]: isCircleFrosted,
            })}
            onTouchStart={() => toggleActive(true)}
            onTouchEnd={() => toggleActive(false)}
            onClick={onClick}
            data-tn={dataTn}
            type="button"
        >
            {isCircleFrosted ? (
                <div
                    className={classnames(dibsCss.cursorPointer, {
                        [styles.isFilled]: isInFolder,
                        [styles.circleFrosted]: isCircleFrosted,
                        [styles.circleFrostedSmall]: isCircleFrostedSmall,
                        [styles.circleFrostedMedium]: isCircleFrostedMedium,
                        [styles.circleFrostedLarge]: isCircleFrostedLarge,
                    })}
                >
                    <FolderIconCircleFrosted variation={variation} />
                </div>
            ) : (
                <div
                    className={classnames(styles.folder, {
                        [styles[type]]: type,
                        [styles.circle]: isCircleLight,
                    })}
                >
                    <Folder className={iconClasses} />
                    {!isCircleLight && (
                        <div className={iconShadowClasses} onAnimationEnd={onAnimationEnd} />
                    )}
                </div>
            )}
        </button>
    );
};

export default FolderIconWrapper;
